export enum RechercheColonneEnum {
    NUMERO_DOSSIER = "numeroDossier",
    LIBELLE_FORMATION = "libelleFormation",
    REFERENCE_FORMATION = "referenceFormation",
    MONTANT_A_PAYER = "montantAPayer",
    DATES_FORMATION = "dates",
    DATE_CREATION = "dateCreation",
    STAGIAIRES = "stagiaires"
}